import * as $ from "jquery";

export const resolutions_page = () => {

    $("#resolutionsTable").DataTable({
        "order": [[0, "desc"]],
        "stateSave": false,
    })
}
